// Program data for AIOU International Students (Spring 2026).
// All fee figures and eligibility are based on the official AIOU Directorate
// of International Collaboration & Exchange prospectuses (Spring-2026).

export const KAMRAN = {
  name: "Kamran Mir",
  phone: "+353851511839",
  phoneDisplay: "+353 85 151 1839",
  email: "kamranmir99@gmail.com",
  region: "Europe",
};

export const WHATSAPP_LINK = (msg) =>
  `https://wa.me/${KAMRAN.phone.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(
    msg ||
      "Assalam-o-Alaikum, I am interested in applying to AIOU and would like free guidance.",
  )}`;

export const EMAIL_LINK = (subject, body) =>
  `mailto:${KAMRAN.email}?subject=${encodeURIComponent(
    subject || "AIOU International Admission Guidance",
  )}&body=${encodeURIComponent(body || "Assalam-o-Alaikum,\n\nI'd like guidance on applying to AIOU as an international student.\n\nProgram interested in:\nCurrent country:\nLast qualification:\n\nThank you.")}`;

export const SOURCE_PAGE =
  "https://www.aiou.edu.pk/directorate-international-collaboration-exchange-0";

export const OFFICIAL_APPLICATION =
  "https://fmbp.aiou.edu.pk/application/index.php";

// Universal fee structure for international students (per Spring-2026
// prospectuses; same across almost every program).
export const FEE_STRUCTURE = {
  registration: 50, // USD, one-time
  admission: 50, // USD, one-time
  perCourse: 100, // USD per 3-credit course
  // First-semester totals depend on courses count:
  totalFiveCourses: 600, // 50 + 50 + (100 × 5)
  totalSixCourses: 700, // 50 + 50 + (100 × 6)
};

export const PROGRAMS = [
  {
    id: "matric",
    title: "Matric (SSC) & Open Courses",
    level: "Secondary",
    tagline: "Complete your school certification from anywhere in the world.",
    eligibility: "Class 8 pass or equivalent.",
    duration: "2 years (4 semesters) — ODL mode",
    highlights: [
      "Choose Matric General or specialised Open Courses",
      "Fully distance-learning with online study material",
      "Recognised by IBCC for international equivalence",
    ],
    firstSemFee: 600,
    courses: 5,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/1. Prospectus SSC - SSC Open Courses (Spring-2026).pdf",
  },
  {
    id: "intermediate",
    title: "Intermediate (FA / I.Com / HSSC)",
    level: "Higher Secondary",
    tagline: "Earn your FA, I.Com or HSSC certification online.",
    eligibility: "Matric / SSC or equivalent.",
    duration: "2 years (4 semesters) — ODL mode",
    highlights: [
      "FA, I.Com, HSSC General or HSSC Open Courses",
      "Stepping stone to AIOU Bachelor's degrees",
      "International candidates supported through the Overseas directorate",
    ],
    firstSemFee: 600,
    courses: 5,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/2. Prospectus HSSC - I.Com - HSSC Open Courses (Spring-2026).pdf",
  },
  {
    id: "associate",
    title: "Associate Degree (BA · B.Com · Open Courses)",
    level: "Undergraduate (2-yr)",
    tagline:
      "A 2-year undergraduate degree — perfect bridge to a full BS later.",
    eligibility: "FA / FSc / I.Com / HSSC with at least 45% marks.",
    duration: "2 years (4 semesters) — ODL mode",
    highlights: [
      "Multiple specialisations available",
      "Credits transferable to BS programs",
      "HEC-recognised undergraduate qualification",
    ],
    firstSemFee: 700,
    courses: 6,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/3. Prospectus Associate Degree Programs BA - B.Com - Open Courses (Spring-2026).pdf",
  },
  {
    id: "ad-edu-ba",
    title: "Associate Degree — Education & Business Administration",
    level: "Undergraduate (2-yr)",
    tagline:
      "Specialised 2-year undergraduate degrees in two of AIOU's strongest faculties.",
    eligibility: "Intermediate / FA / FSc / I.Com (45%+).",
    duration: "2 years (4 semesters) — ODL mode",
    highlights: [
      "Associate Degree in Education (ADE)",
      "Associate Degree in Business Administration (ADBA)",
      "Both routes feed directly into B.Ed / BBA",
    ],
    firstSemFee: 700,
    courses: 6,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/4. AD Education - Business Administration (Spring-2026).pdf",
  },
  {
    id: "bed",
    title: "B.Ed (1.5 / 2.5 / 4 Years)",
    level: "Undergraduate (Teaching)",
    tagline:
      "The most popular AIOU teaching qualification — recognised across the GCC, UK and beyond.",
    eligibility:
      "4-Year: FA/FSc (45%+). 2.5-Year: BA/BSc. 1.5-Year: BA/BSc + ADE.",
    duration: "1.5, 2.5 or 4 years — ODL mode",
    highlights: [
      "Three pathways for different prior qualifications",
      "Strongest recognition for overseas teachers",
      "Online classes, online exams, online assignments",
    ],
    firstSemFee: 700,
    courses: 6,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/5. Prospectus B.Ed - 1.5 Years, 2.5 Years, 4 Years (Spring-2026).pdf",
  },
  {
    id: "pgd",
    title: "Post Graduate Diploma (PGD)",
    level: "Post-Graduate Diploma",
    tagline:
      "1-year professional diplomas to specialise after your Bachelor's.",
    eligibility: "14-Year (Bachelor's) degree in any discipline.",
    duration: "1 year (2 semesters) — ODL mode",
    highlights: [
      "PGD in HRM, Supply Chain Management, Entrepreneurship",
      "PGD in Educational Planning & Management, ECCE, ELM",
      "Career-focused, industry-aligned curriculum",
    ],
    firstSemFee: 600,
    courses: 5,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/6. Prospectus Postgraduate Diploma (Spring-2026).pdf",
  },
  {
    id: "bs-bba",
    title: "BS / BBA (4 Yr · 2.5 Yr · AD Based)",
    level: "Bachelor's (4-year)",
    tagline:
      "Full BS and BBA degrees with multiple specialisations and three entry routes.",
    eligibility:
      "4-Year: FA/FSc (45%+). 2.5-Year: BA/BSc (45%+). AD-Based: Associate Degree.",
    duration: "2 to 4 years — ODL mode",
    highlights: [
      "BS English, BS CS, BS Accounting & Finance, BS Sociology, BS Pak Studies, BS Mass Comm, BS Islamic Finance, BS GWS, BS Economics, BS Urdu, BS Arabic, BS Environmental Studies, BS History",
      "BBA (Bachelor of Business Administration)",
      "Same fee structure across all majors",
    ],
    firstSemFee: 700,
    courses: 6,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/7. Prospectus BS-BBA (4 Years, 2.5 Years, AD Based) (Spring-2026).pdf",
  },
  {
    id: "col-mba",
    title: "COL MBA / MPA",
    level: "Master's",
    tagline:
      "Professional management Master's run jointly with the Commonwealth of Learning.",
    eligibility:
      "Bachelor's degree (14 years of education) in any discipline.",
    duration: "2 years (4 semesters) — ODL mode",
    highlights: [
      "MBA specialisations: Banking & Finance, HRM, Marketing, etc.",
      "MPA for public-administration professionals",
      "Globally portable Commonwealth-of-Learning credential",
    ],
    firstSemFee: 700,
    courses: 6,
    prospectus:
      "https://result.aiou.edu.pk/admissions/Spring_2026/Oversease/8. COL MBA-MPA (Spring-2026).pdf",
  },
];

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Reach out to Kamran",
    body: "WhatsApp or email Kamran Mir with your country, last qualification and the programs you're considering. Replies usually come within 24 hours — completely free of charge.",
  },
  {
    n: "02",
    title: "Choose the right program",
    body: "Kamran will walk you through eligibility, duration and total fees for each program that fits your background, so you pick the one that best matches your goals.",
  },
  {
    n: "03",
    title: "Submit your online application",
    body: "Kamran personally helps you fill the official AIOU application form, upload documents, complete attestation and pay fees from abroad — step by step.",
  },
  {
    n: "04",
    title: "Start studying — 100% online",
    body: "Once admitted, you study from home through AIOU's Aaghi LMS. Assignments are submitted online and most overseas exams are conducted online too.",
  },
];

export const FAQS = [
  {
    q: "Is AIOU's degree recognised internationally?",
    a: "Yes. AIOU is chartered by an Act of Parliament and recognised by the Higher Education Commission (HEC) of Pakistan. After the standard attestation chain (HEC → Ministry of Foreign Affairs → destination-country embassy), AIOU degrees are accepted by overseas universities for higher studies and by employers across the GCC, UK, USA, Canada and Australia.",
  },
  {
    q: "Are the exams fully online for overseas students?",
    a: "For most programs, yes. Assignments and workshops are conducted online through AIOU's Aaghi LMS, and final examinations for overseas students are run online with remote proctoring. A small number of programs may still require an exam at a designated AIOU overseas centre — confirm the mode in your admission letter.",
  },
  {
    q: "How much does it cost in total for the first semester?",
    a: "The universal pattern is: US$ 50 Registration (one-time) + US$ 50 Admission (one-time) + US$ 100 per 3-credit-hour course. First-semester total is US$ 600 for programs with 5 courses and US$ 700 for programs with 6 courses. Fees for subsequent semesters are communicated at the time of each admission.",
  },
  {
    q: "How do I pay fees from abroad?",
    a: "AIOU accepts payment in USD via bank draft, online card payment and through designated overseas bank accounts listed in the prospectus. Kamran can walk you through the easiest method for your country.",
  },
  {
    q: "Do I need to travel to Pakistan?",
    a: "For the vast majority of overseas students, no. Study material, classes, assignments and exams are all online. You only need to attest your final degree once you graduate.",
  },
  {
    q: "What is the role of Kamran Mir?",
    a: "Kamran is an AIOU alumnus based in Europe who volunteers free guidance to international students. He is not a paid agent — there are no service charges. He simply helps you understand the right program, complete the official application correctly and avoid common mistakes.",
  },
  {
    q: "Which countries does Kamran support?",
    a: "Anywhere in Europe — Ireland, UK, Germany, France, Spain, Italy, the Netherlands, Scandinavia and others. He can also help students based outside Europe with the AIOU application process.",
  },
];
